import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { ZiggyVue } from '@/../../vendor/tightenco/ziggy';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import ApplicationDefaultsMixin from "@/mixins/shared/applicationDefaults.js";

createInertiaApp({
	title: (title) => `${title}`,
	resolve: name => resolvePageComponent(
		`/resources/js/pages/${name}.vue`,
		import.meta.glob([
			'/resources/js/pages/**/*.vue',
			'!/resources/js/pages/components/**',
			'!/resources/js/pages/translation/translate.vue',
			'!/resources/js/pages/translation/translate-modal.vue',
			'!/resources/js/pages/layouts/**',
		])
	),
	setup({ el, App, props, plugin }) {
		return createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(ZiggyVue)
			.mixin(ApplicationDefaultsMixin)
			.mount(el);
	},
	progress: {
		color: '#4B5563',
	},
});

$(document).on('click', 'a[data-dt-btn="edit"], a[data-inertia-link]', (event) => {
	event.preventDefault();
	router.get($(event.currentTarget).attr('href'));
});